/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 outfit8.glb 
*/

import React from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/outfit8.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				geometry={nodes.hair001.geometry}
				material={materials["hair_defaultMat4.001"]}
				position={[0.005, 0.028, 0.291]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.hair001_1.geometry}
				material={materials["Dummy_SHD1.001"]}
				position={[0.005, 0.028, 0.291]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.Retopo_body002.geometry}
				material={materials["Fabric.003"]}
				position={[0.005, 0.028, 0.291]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.Retopo_Cube002.geometry}
				material={materials["Clean silver(Shiny Metal).002"]}
				position={[0.008, 14.155, 0.159]}
			/>
			<mesh
				geometry={nodes.Retopo_shoes_r003.geometry}
				material={materials["Material.001"]}
				position={[0.005, 0.028, 0.291]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.Retopo_WrapMaster001.geometry}
				material={materials["Clean silver(Shiny Metal).002"]}
				position={[0, 16.231, -0.445]}
				rotation={[0.153, 0, 0]}
				scale={[22.645, 22.645, 26.265]}
			/>
			<mesh
				geometry={nodes.skirtsimple_1.geometry}
				material={materials["Fabric.001"]}
				position={[0, -1.152, 0.275]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.011, 0.012, 0.012]}
			/>
			<mesh
				geometry={nodes.skirtsimple_2.geometry}
				material={materials["Clean silver(Shiny Metal).001"]}
				position={[0, -1.152, 0.275]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.011, 0.012, 0.012]}
			/>
			<mesh
				geometry={nodes.skirtsimple_3.geometry}
				material={materials["blackStrip.001"]}
				position={[0, -1.152, 0.275]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.011, 0.012, 0.012]}
			/>
		</group>
	);
}

useGLTF.preload("models/outfit8.glb");
